import dynamicImport from 'components/dynamicImport';
import OpenRoundConfirmationFallback from './OpenRoundConfirmation';

export const OpenRoundConfirmation = dynamicImport({
  component: '/containers/Sale/Prompts/OpenRoundConfirmation',
  fallback: OpenRoundConfirmationFallback,
});

export * from './Prompts';
export * from './BlockUser';



// WEBPACK FOOTER //
// ./src/app/containers/Sale/Prompts/index.js